/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styles from './styles.scss';

const defaultProps = {
  highlight: false,
  onHighlightExited: () => {},
};

const propTypes = {
  locale: PropTypes.string.isRequired,
  highlight: PropTypes.bool,
  onHighlightExited: PropTypes.func,
};

class AddFlowHelp extends React.Component {

  static renderZh(locale) {
    const tooltip = <Tooltip id="flow-zh">文档</Tooltip>;
    return (
      <div>
        <h3>规则示例:单Branch&nbsp;
          <OverlayTrigger placement="top" overlay={tooltip}>
            <Link onClick={() => { window.open(`https://loraflow.io/static/docs/${locale}/application/Flow.html`); }}>
              <i className="fa fa-question-circle" />
            </Link>
          </OverlayTrigger>
        </h3>
        <section>
          <h4>温度(数据点temperature)超过30度，发送通知</h4>
          <code>
            {'temperature | temperature > 30 | warn "#deveui 温度超过30度" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>温度(数据点temperature)超过30度，连续发生10次，发送通知</h4>
          <code>
            {'temperature | temperature > 30 | repeat 10 | error "#deveui 温度超过30度10次" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>统计最近10条温度消息的平均值，发送通知</h4>
          <code>
            {'temperature | window 10 | avg as avgtemperature | info "#avgtemperature" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>
            统计最近30分钟的温度平均值，如果平均值大于35，发送通知
          </h4>
          <code>
            {'temperature | window 30 min | avg as avgtemperature | avgtemperature > 35 | warn " #deveui 30分钟内，平均温度超过35度" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>
            发现设备状态异常(0为正常，1为异常)，发送通知
          </h4>
          <code>
            {'Status | 0 -> 1 | warn " #deveui 状态异常 " -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>发现设备状态恢复，发送通知</h4>
          <code>
            {'Status | 1 -> 0 | success " #deveui 状态恢复 " -> test@aisenz.com'}
          </code>
        </section>

        <h3>规则示例:多Branch</h3>
        <section>
          <h4>检测设备温度，如果温度从30度以下升高到30度以上，发送温度过高通知; 如果温度下降到30度以下发送温度恢复正常通知</h4>
          <code>
            {'temperature'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|change temperature <30 -> temperature >=30'}
          </code>
          <code>
            {'|error "temperatureemperature is too high"  -> test@aisenz.com'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|change temperature >=30 -> temperature <30'}
          </code>
          <code>
            {'|success "temperaturehe temperature returned to normal" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>发现设备状态异常(0为正常，1为异常)，发送通知;发现设备状态恢复，发送通知</h4>
          <code>
            {'DeviceStatus'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|0 -> 1'}
          </code>
          <code>
            {'|warn " #deveui abnormal status " -> test@aisenz.com'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|1 -> 0'}
          </code>
          <code>
            {'|success " #deveui status restored " -> test@aisenz.com'}
          </code>
        </section>


        <section>
          <h4>以2小时为周期检测数据连接状态，如果两个检测周期内设备没有数据上传，发送失联通知;如果收到设备数据，发送失联恢复通知</h4>
          <code>
            {'DeviceStatus'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|timeout 2 hour'}
          </code>
          <code>
            {'|error " Lost connection：device[#deveui]" ->test@aisenz.com'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|recover'}
          </code>
          <code>
            {'|success " Resume connection：device[#deveui]" ->test@aisenz.com'}
          </code>
        </section>


        <h3>
          表达式判断(Expression)
        </h3>
        <section>
          <code>
            {'>, <, ==, >=, <=, !='}
          </code>
          <code>
            {'and, or, not'}
          </code>
        </section>

        <h3>窗口(Window)</h3>
        <section>
          <h4>长度窗口</h4>
          <code>window 10</code>
        </section>
        <section>
          <h4>时间窗口</h4>
          支持
          <ul>
            <li>sec</li>
            <li>min</li>
            <li>hour</li>
            <li>day</li>
          </ul>
          <code>
            window 10 sec
          </code>
          <code>
            window 10 min
          </code>
        </section>

        <h3>聚合类型(Agg)</h3>
        <section>
          <ul>
            <li>sum</li>
            <li>avg</li>
            <li>max</li>
            <li>min</li>
            <li>count</li>
          </ul>
        </section>

        <h3>通知级别（Level）</h3>
        <seciton>
          <ul>
            <li>info</li>
            <li>warn</li>
            <li>error</li>
            <li>success</li>
          </ul>
        </seciton>

      </div>
    );
  }

  static renderEn(locale) {
    const tooltip = <Tooltip id="flow-en">Docs</Tooltip>;
    return (
      <div>
        <h3>Rule Examples:Single  Branch&nbsp;
          <OverlayTrigger placement="top" overlay={tooltip}>
            <Link onClick={() => { window.open(`https://loraflow.io/static/docs/${locale}/application/Flow.html`); }}>
              <i className="fa fa-question-circle" />
            </Link>
          </OverlayTrigger>
        </h3>
        <section>
          <h4>When the temperature(DataPoint temperature) is greater than 30 degree, send notifications.</h4>
          <code>
            {'temperature | temperature > 30 | warn "#deveui temperature is higher than 30 degree" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>When 10 successive temperatures which greater than 30 degree observed, send notifications.</h4>
          <code>
            {'temperature | temperature > 30 | repeat 10 | error "#deveui is higher than 30 degree for 10 times" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>Calculate the average of the latest 10 temperature records and send notifications.</h4>
          <code>
            {'temperature | window 10 | avg as avgtemperature | info "#avgtemperature" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>
            If the average temperate in 30 minutes is greater than 35, send notifications.
          </h4>
          <code>
            {'temperature | window 30 min | avg as avgtemperature | avgtemperature > 35 | warn " #deveui the average temperature in 30 minutes is higher than 35 degree" -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>
            If a abonormal status observed(0 is normal，1 is abnormal), send notifications.
          </h4>
          <code>
            {'DeviceStatus | 0 -> 1 | warn " #deveui abnormal status " -> test@aisenz.com'}
          </code>
        </section>
        <section>
          <h4>When status restored, send notifications.</h4>
          <code>
            {'DeviceStatus | 1 -> 0 | success " #deveui status restored " -> test@aisenz.com'}
          </code>
        </section>

        <section>
          <h4>Check temperature and humidity at the same time. Send notifications if the temperature is above 30 and the humidity is above 65.</h4>
          <code>
            {'|change temperature <=30 or humidity<=65 -> temperature>30 and humidity>65'}
          </code>
          <code>
            {'|error  "temperaturehe temperature and humidity are over standard"  -> test@aisenz.com'}
          </code>
        </section>

        <h3>Rule Examples:Multi Branch</h3>
        <section>
          <h4>if the temperature rises from 30 degrees or less to 30 degrees or more, the temperature is notified too high; If the temperature drops below 30 degrees, the temperature is notified to return to normal.</h4>
          <code>
            {'temperature'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|change temperature <30 -> temperature >=30'}
          </code>
          <code>
            {'|error "temperatureemperature is too high"  -> test@aisenz.com'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|change temperature >=30 -> temperature <30'}
          </code>
          <code>
            {'|success "temperaturehe temperature returned to normal" -> test@aisenz.com'}
          </code>
        </section>

        <section>
          <h4>If a abonormal status observed(0 is normal，1 is abnormal), send notifications; When status restored, send notifications.</h4>
          <code>
            {'DeviceStatus'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|0 -> 1'}
          </code>
          <code>
            {'|warn " #deveui abnormal status " -> test@aisenz.com'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|1 -> 0'}
          </code>
          <code>
            {'|success " #deveui status restored " -> test@aisenz.com'}
          </code>
        </section>


        <section>
          <h4>temperaturehe data connection status is detected in 2 hour cycles. If the device fails to upload data during the two detection cycle, the loss of notification is sent; if the device data is received, a loss recovery notification is sent.</h4>
          <code>
            {'DeviceStatus'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|timeout 2 hour'}
          </code>
          <code>
            {'|error " Lost connection：device[#deveui]" ->test@aisenz.com'}
          </code>
          <code>
            {'|if'}
          </code>
          <code>
            {'|recover'}
          </code>
          <code>
            {'|success " Resume connection：device[#deveui]" ->test@aisenz.com'}
          </code>
        </section>
        <h3>Expression</h3>
        <section>
          <code>
            {'>, <, ==, >=, <=, !='}
          </code>
          <code>
            {'and, or, not'}
          </code>
        </section>

        <h3>Window</h3>
        <section>
          <h4>length window</h4>
          <code>window 10</code>
        </section>
        <section>
          <h4>time window</h4>
          Supported:
          <ul>
            <li>sec</li>
            <li>min</li>
            <li>hour</li>
            <li>day</li>
          </ul>
          <code>
            window 10 sec
          </code>
          <code>
            window 10 min
          </code>
        </section>

        <h3>Aggregation</h3>
        <section>
          <ul>
            <li>sum</li>
            <li>avg</li>
            <li>max</li>
            <li>min</li>
            <li>count</li>
          </ul>
        </section>

        <h3>Level</h3>
        <seciton>
          <ul>
            <li>info</li>
            <li>warn</li>
            <li>error</li>
            <li>success</li>
          </ul>
        </seciton>
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      locale: props.locale,
      highlight: props.highlight,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { locale, highlight } = nextProps;
    if (locale !== this.props.locale) {
      this.setState({ locale });
    }
    if (highlight !== this.props.highlight) {
      this.setState({ highlight });
      if (highlight) {
        _.delay(() => this.props.onHighlightExited(), 1000);
      }
    }
  }

  render() {
    const { locale, highlight = false } = this.state;

    let content;
    if (locale === 'zh') {
      content = AddFlowHelp.renderZh(locale);
    } else {
      content = AddFlowHelp.renderEn(locale);
    }
    return (
      <div className={`${styles.help} ${highlight ? styles.highlight : ''}`}>
        {content}
      </div>
    );
  }
}

AddFlowHelp.propTypes = propTypes;
AddFlowHelp.defaultProps = defaultProps;

const mapStatetemperatureoProps = state => ({
  locale: state.intl.locale,
});

export default connect(mapStatetemperatureoProps, null)(injectIntl(AddFlowHelp));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/AddFlowHelp/index.jsx